'use strict';
(function($){
	/*
	 * Vetology.FileUpload widget
	 *
	 * @description Helper class to upload files
	 *
	 * @options					See description for each option
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.FileUpload',
		{
			"options": {
				"server": "",
				"types": ["*"],
				"extraColumns": function(){return "";},
				"uploadCallback": function(){},
				"removeCallback": function(){},
				"restoreCallback": function(){},
				"queue": 0,
				"text_alternate": {
					'before': 'Drag and drop all your files here or alternatively',
					'link': 'click here',
					'after': 'to find them in your device.'
				}
			},
			/*
			 * Vetology.FileUpload._init
			 *
			 * @description	Initializes the File Upload helper
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				o.options.id = o._randomId("NewCase");
				o.options.filename = typeof o.element.data("filename") === "undefined" ? "IMAGES" : o.element.data("filename");
				o.options.trash = typeof o.element.data("trash") === "undefined" ? true : false;
				o.options.target = o.element.data("target");
				o.options.server = typeof o.element.data("url") != "undefined" ? o.element.data("url") : "/";
				var html = o._getHTML();
				o.element.html(html);
				o.options.fileInput = o.element.find('input');
				o.options.fileInputToggler = o.element.find('a');
				o.options.dropArea = o.element.find('.docs_uploader_inner');
				o.options.dropLog = o.element.find('.docs_uploader_console');
				o.options.dropProgress = o.element.find('.docs_uploader_progress');
				o.options.dropProgressTable = o.options.dropProgress.find("tbody");
				o._initFileHandler();
				o._initEventHandler();
				o._initDeleteHandler();
			},
            _destroy: function() {
                var o = this;
                o.element.off('click');
                $('.uploaded_files').off('click', '.deleteFile', false);
            },
			/*
			 * Vetology.FileUpload.setExtra
			 *
			 * @description	Sets additional post data
			 *
			 * @return String
			 *
			 */
			"setExtra": function(extra){
				this.options.extra = extra;
			},
			/*
			 * Vetology.FileUpload._getHTML
			 *
			 * @description	Returns the HTML necesary for the plugin to function
			 *
			 * @return String
			 *
			 */
			"getID": function(){
				return this.options.id;
			},
			/*
			 * Vetology.FileUpload._getHTML
			 *
			 * @description	Returns the HTML necesary for the plugin to function
			 *
			 * @return String
			 *
			 */
			"_getHTML": function(){
				var o = this;
				var html = '<div class="docs_uploader_inner">';
				html += '<span>DROP YOUR ' + o.options.filename + ' <i class="vetology-drop-file"></i> HERE TO UPLOAD</span>';
				html += '<p class="docs_uploader_alternate">' + o.options.text_alternate.before + ' <a href="javascript:void(0)" class="docs_uploader_alternate">' + o.options.text_alternate.link + '</a> ' + o.options.text_alternate.after + '<input type="file" multiple="multiple" class="hide">';
				html += '<div class="docs_uploader_console"></div>';
				html += '<div class="docs_uploader_progress table-responsive hide">';
				html += '<table class="table table-striped">';
				html += '<thead>';
				html += '<tr>';
				html += '<th>File name</th>';
				html += '<th>File size</th>';
				html += '<th>Mime type</th>';
				html += '<th>Preview</th>';
				html += '<th>Upload progress</th>';
				html += o.options.extraColumns();
				html += '<th></th>';
				html += '</tr>';
				html += '</thead">';
				html += '<tbody>';
				html += '</tbody>';
				html += '</table>';
				html += '</div>';
				html += '</div>';
				return html;
			},
			/*
			 * Vetology.FileUpload._initEventHandler
			 *
			 * @description	Initializes the events for file uploads such as retry and file remove
			 *
			 * @return String
			 *
			 */
			"_initEventHandler": function(){
				var o = this;
				o.element.on("click", ".file_remover", function(){
					var el = $(this);
					var row = el.closest("tr");
					row.addClass("remove_file danger");
					var $rowOverlapper = $("<div class='remove-file-overlapper' />");
					$rowOverlapper.text("File removed, click to undo");
					$rowOverlapper.css({
                        position: 'absolute',
                        top: row.position().top,
                        left: row.position().left,
                        width: row.width(),
                        height: row.height(),
                        backgroundColor: 'rgba(33, 33, 33, 0.75)',
                        zIndex: 1000,
                        textAlign: 'center',
                        lineHeight: '50px',
                        color: 'white'
                    });
					$rowOverlapper.data('rowclass', row.attr('class').split(' ')[0]);
					row.closest('table').append($rowOverlapper);

					o.options.removeCallback(row);
				});
				o.element.on("click", ".remove-file-overlapper", function(){
					var el = $(this);
					var $row = $('tr.' + el.data('rowclass'));
                    $row.removeClass("remove_file danger");
                    el.remove();
                    o.options.restoreCallback($row);
				});
				o.element.on("click", ".file_retry", function(){
					var el = $(this);
					var row = el.closest("tr");
					row.find(".file_remover").addClass("hide");
					row.find(".file_retry").addClass("hide");
					var file = row.data("file");
					o._uploadFile(file);
				});
			},
			/*
			 * Vetology.FileUpload._initFileHandler
			 *
			 * @description	Initializes the file handler
			 *
			 * @return String
			 *
			 */
			"_initFileHandler": function(){
				var o = this;
				var fileAPI = !!('File' in window &&
								  'FileReader' in window &&
								  'FileList' in window &&
								  'Blob' in window);
				if(fileAPI){
					o.options.fileInputToggler.on('click', function(e){
                        if (e.target === e.currentTarget) {
                            e.stopPropagation();
                            const target = o.options.fileInput.get(0);
                            const clickEvent = new MouseEvent('click', {
                                bubbles: false,
                                target: target,
                                eventTarget: target
                            });
                            target.dispatchEvent(clickEvent);
                        }
					});
					$(document).off('dragover', o.options.dropArea);
					$(document).off('dragleave', o.options.dropArea);
					$(document).off('drop', o.options.dropArea);
					o.options.dropArea.on('dragover', function(e){
						e.preventDefault();
						var dt = e.originalEvent.dataTransfer;
						if(dt.types != null && (
								dt.types.indexOf ? dt.types.indexOf('Files') != -1 : 
								(dt.types.contains('application/x-moz-file') ||
									(typeof dt.types[0] != 'undefined' && dt.types[0].indexOf('Files') != -1))
							)
						){
							o.element.addClass('docs_detected');
							o.options.dropLog.html('File detected, drop it anytime now.');
						} else {
							o.element.removeClass('docs_detected');
							o.options.dropLog.html('Something not recognized coming in, I only accept files, try with something else.');
						}
					});
					o.options.dropArea.on('dragleave', function(e) {
						o.element.removeClass('docs_detected');
						o.options.dropLog.html('');
					});
					o.options.dropArea.on('drop', function(e) {
						e.preventDefault();
						var dt = e.originalEvent.dataTransfer;
						o.element.removeClass('docs_detected');
						o.options.dropLog.html('Pre-Processing your files, please wait');
						if(
							dt.types != null && 
								(
									dt.types.indexOf ? dt.types.indexOf('Files') != -1 : 
									(
										dt.types.contains('application/x-moz-file')
										||
										(
											typeof dt.types[0] != 'undefined' && dt.types[0].indexOf('Files') != -1
										)
									)
								)
						){
							o.options.dropLog.html('File received, processing for upload.');
							o._uploadFiles(e.originalEvent.dataTransfer.files);
						} else {
							o.options.dropLog.html('The item you dropped is not a file, try using a file instead');
						}
					});
					o.options.fileInput.on('change', function(e){
						o._uploadFiles(e.target.files);
					});
				} else {
					console.error("This browser can't handle file uploads");
				}
			},
			/*
			 * Vetology.FileUpload._randomId
			 *
			 * @description	Initializes the file handler
			 *
			 * @return String
			 *
			 */
			"_randomId": function(initText){
				var randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
				var id = initText.replace(/\s+/g, '-').replace(/[^a-zA-Z-]/g, '').toLowerCase().trim() + randLetter + Date.now();
				return id;
			},
			/*
			 * Vetology.FileUpload._uploadFiles
			 *
			 * @description	Initializes the file handler
			 *
			 * @return String
			 *
			 */
			"_uploadFiles": function(files){
				var o = this;
				if(files.length > 0){
					o.options.dropProgress.removeClass("hide");
					$.each(files, function(i, file){
						file.id = o._randomId(file.name);
						var html = o._getFileRowHTML(file);
						html = $(html);
						html.data("file", file);
						o.options.dropProgressTable.append(html);
						o.options.queue ++;
						o._uploadFile(file);
					});
				}
			},
			/*
			 * Vetology.FileUpload._uploadFile
			 *
			 * @description	Uploads a single filer
			 *
			 * @return null
			 *
			 */
			"_uploadFile": function(file){
				var o = this;
				var loader = $('.' + file.id);
				loader.find('.progress-bar').removeClass('progress-bar-danger').addClass('active progress-bar-striped').html('Retrying...');
				var formData = new FormData;
				formData.append('upload', file);
				var has_case_id = false;
				if(o.options.extra){
					$.each(o.options.extra, function(i, e){
						if(i == "case_id"){
							has_case_id = true;
						}
						formData.append(i, e);
					});
				}
				if(!has_case_id){
                    if ('case_id' in document.body.dataset) {
                        formData.append('case_id', document.body.dataset.case_id);
                    } else {
                        formData.append('case_id', o.options.id);
                    }
				}
				formData.append('type', o.options.target);
				$("body").Vetology("preflight", function(preflight){
					formData.append('preflight', preflight);
					o.performUpload(file, formData, loader);
				});
			},

			"performUploadCallback": function (e, file, percentage, loader, timeStart) {
				if (e.lengthComputable) {
					percentage = ((e.loaded / file.size) * 100).toFixed(2);
					percentage = percentage > 100 ? 100 : percentage;
					var loaded = e.loaded;
					var total = e.total;
					var progressValue = Math.round((loaded / total) * 100);
					var seconds_elapsed = (new Date().getTime() - timeStart.getTime()) / 1000;
					var bytes_per_second = seconds_elapsed ? loaded / seconds_elapsed : 0;
					var Kbytes_per_second = bytes_per_second / 1000;
					var remaining_bytes = total - loaded;
					var seconds_remaining = seconds_elapsed ? remaining_bytes / bytes_per_second : 'calculating';
					Kbytes_per_second = Kbytes_per_second.toFixed(2);
					loader.find('.progress-bar').css({ width: percentage + '%' }).html(percentage + '% at ' + Kbytes_per_second + 'KB per second');
				}
			},

			"performUpload": function (file, formData, loader) {
				var o = this;
				var percentage = 0;
				$.ajax({
					url: o.options.server + 'upload',
					type: 'POST',
					xhr: function () {
						var xhr = $.ajaxSettings.xhr();
						var timeStart = new Date();
						if (xhr.upload) {
							xhr.upload.addEventListener(
								'progress',
								function (e) {
									o.performUploadCallback(e, file, percentage, loader, timeStart);
								},
								false
							);
						}
						return xhr;
					},
					beforeSend: function () { },
					success: function (data) {
						var row = loader.closest("tr");
						o.options.queue--;
						if (typeof data.error != "undefined" && data.error) {
							loader.find('.file_retry').removeClass('hide');
							loader.find('.progress-bar').removeClass('active progress-bar-striped').addClass('progress-bar-danger').html(data.error);
						} else {
							row.data("data", data);
							row.find(".file_mime_type").html(data.mime);
							if (data.base64) {
								loader.find('.base64_preview').html('<img src="' + data.base64 + '">');
							}
							if (o.options.trash) {
								loader.find('.file_remover').removeClass('hide').data("id", data.name);
								if (data.frames && data.frames > 1) {
									loader.find('.file_remover').data("id", data.id);
								}
							}
							loader.find('.progress-bar').removeClass('active progress-bar-striped').addClass('progress-bar-success').html('Completed');
							o.options.uploadCallback(loader, data);
						}
					},
					error: function (a, b, c) {
						o.options.queue--;
						loader.find('.file_retry').removeClass('hide');
						const message = (typeof a.responseJSON != 'undefined' && a.responseJSON.message ? a.responseJSON.message : a.responseText);
						loader.find('.progress-bar').removeClass('active progress-bar-striped').addClass('progress-bar-danger').html(message ? message : "FAILED");
					},
					data: formData,
					cache: false,
					contentType: false,
					processData: false,
					dataType: 'JSON'
				});
			},
			/*
			 * Vetology.FileUpload._getFileRowHTML
			 *
			 * @description	Returns the HTML for a file table row
			 *
			 * @return String
			 *
			 */
			"_getFileRowHTML": function(file){
				var o = this;
				var html = '<tr class="' + file.id + '">';
				html += '<td class="file_name">' + file.name + '</td>';
				html += '<td class="file_size">' + file.size + '</td>';
				html += '<td class="file_mime_type">' + file.type + '</td>';
				html += '<td class="base64_preview">N/A</td>';
				html += '<td>';
				html += '<div class="progress">';
				html += '<div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:0%">';
				html += '0%';
				html += '</div>';
				html += '</div>';
				html += '</td>';
				html += o.options.extraColumns(file);
				html += '<td>';
				html += '<a href="#" class="file_remover hide vetology_pd"><span class="vetology-delete"></span></a>';
				html += '<a href="#" class="file_retry hide vetology_pd"><span class="vetology-loop"></span></a>';
				html += '</td>';
				html += '</tr>';
				return html;
			},

            '_initDeleteHandler': function() {
                $('.uploaded_files').on('click', '.deleteFile', function(e){
                    e.preventDefault();
                    e.stopPropagation();
                    let $el = $(e.target);
                    if ($el.closest('tr').length === 0) {
                        return;
                    }
                    $.ajax({
                        url: '/ca/do/u',
                        type: 'POST',
                        success: function(data){
                            if(data.deleted){
                               $el.closest('tr').remove();
                            } else {
                                alert(data.reason);
                            }
                        },
                        error: function(){},
                        data: {
                            id		: $(this).data('id'),
                            action	: 2
                        },
                        dataType	: 'JSON'
                    });
                    $el.closest('.uploadForm').find('.closeLevel,.andCloseLevel').addClass('doRefresh');
                });
            },

			/*
			 * Vetology.FileUpload.uploadsPending
			 *
			 * @description	Returns the amount of pending uploads
			 *
			 * @return Interger
			 *
			 */
			"uploadsPending": function(){
				return this.options.queue;
			}
		}
	);
})(jQuery);
